// extracted by mini-css-extract-plugin
module.exports = {"leftNavi":"App_leftNavi__3LUEw","button":"App_button__2iN8t"};